import React from 'react';
import { withRouter } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './index.scss';

const Admin: React.FC<any> = (props) => {

	return <div className="admin">
		<Header />
		{props.children}
		<Footer />
	</div>
}

export default withRouter(Admin);
